import { render, staticRenderFns } from "./Bahn1Contact.vue?vue&type=template&id=29f5d6cc&scoped=true&"
import script from "./Bahn1Contact.vue?vue&type=script&lang=js&"
export * from "./Bahn1Contact.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1Contact.vue?vue&type=style&index=0&id=29f5d6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f5d6cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
